import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import {
  BeforeYouStartPage,
  IsHazardousPage,
  IssueLocation,
  ProviderSelection,
  UploadPhotoPage,
  CallUsPage,
  SelectEVChargerIssue,
  TellUsMore,
  EmailConfirmation,
  YourDetails,
  Confirmation,
} from './components/pages';
import { RoutesList, steps } from './routes/Routes';
import { basename } from './routes/basename';
import { InternalServerErrorTemplate, NotFoundErrorTemplate } from '@templates';
import { scrollTop } from '@utils';

function App() {
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);

  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}

function Pages() {
  const location = useLocation();

  useEffect(() => {
    scrollTop();
  }, [location.pathname]);

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route
            path={RoutesList.LANDING_PAGE}
            element={<BeforeYouStartPage />}
          />
          <Route
            path={RoutesList.BEFORE_YOU_START}
            element={<BeforeYouStartPage />}
          />
          <Route path={RoutesList.IS_HAZARDOUS} element={<IsHazardousPage />} />
          <Route
            path={RoutesList.PROVIDER_SELECTION}
            element={<ProviderSelection />}
          />
          <Route path={RoutesList.CALL_US} element={<CallUsPage />} />
          <Route
            path={RoutesList.EV_CHARGER_UPLOAD_PHOTO}
            element={<UploadPhotoPage />}
          />
          <Route path={RoutesList.MAP_LOCATION} element={<IssueLocation />} />
          <Route path={RoutesList.ISSUE} element={<SelectEVChargerIssue />} />
          <Route path={RoutesList.TELL_US_MORE} element={<TellUsMore />} />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION}
            element={<EmailConfirmation />}
          />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

// Component to track route changes and log page views
export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

export default App;
